export const getActions = (user) => {
    const actions = {
        actions: [
            {
                label: 'Editar',
                icon: 'edit',
                action: 'edit'
            }
        ],
        extra: []
    };

    if((user.rol_id === 1 || user.responsable)) {
        actions.actions.push({
            label: 'Fusionar',
            icon: 'fusion',
            action: 'fusion'
        })
    }

    return actions;
}